<template>
    <teleport to="body">
        <jet-dialog-modal :id="id" maxWidth="xl" classes="modal-tall" icon="fas fa-print">
            <template #title>{{ title }}</template>
            <template #content>
                <iframe v-if="printUrl" class="print-frame" :src="printUrl" :title="title"></iframe>
            </template>
            <template #footer>
                <jet-button icon="fa fa-print" btn-style="dark" data-dismiss="modal" @click="print">Print</jet-button>
                <jet-button class="ml-2" btn-style="danger" data-dismiss="modal">Close</jet-button>
            </template>
        </jet-dialog-modal>
    </teleport>
</template>

<script>
import JetDialogModal from '@/Jetstream/DialogModal'

export default {
    emits: ['print'],
    props: {
        id: {
            type: String,
            default: 'PrintModal'
        },
        title: {
            type: String,
            default: ''
        },
        printUrl: String
    },
    components: {
        JetDialogModal
    },
    methods: {
        print() {
            this.$emit('print')
        }
    }
}
</script>

<style>
.modal-tall {
    height: 90%;
}

.modal-tall div.modal-content {
    height: 100%;
}

iframe.print-frame {
    width: 100%;
    height: 100%;
    border: none;
}
</style>
